// extracted by mini-css-extract-plugin
export var numpadContainer = "_o6-1";
export var phoneButton = "_o6-0";